// extracted by mini-css-extract-plugin
module.exports = {"range-slider":"styles-module__range-slider___1xbI_"};